<!-- 配送出库列表 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <purchaseOrderTemplate ref="purchaseOrderTemplate"></purchaseOrderTemplate>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form label-width="100px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                              <el-row slot="" v-if="dataActionBox.actionType != 2">
                                 <el-form-item v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow == 1" :label="formOneValue.showField"
                                               :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <el-tooltip class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                effect="dark" :content="String(sendDataInfo[formOneValue.entityField] || '')" placement="bottom-start">

                                       <el-input v-if="formOneValue.entityField == 'incoName'" class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                 :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                 :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                     :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                          </el-button>
                                       </el-input>

                                       <el-input class="form_codition" v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                 :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                 :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)">
                                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                     :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)">
                                          </el-button>
                                       </el-input>
                                       <df-date class="form_codition" v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" :isShowLong="false"
                                                :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)"
                                                v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                       <el-select class="form_codition" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                          <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                                          </el-option>
                                       </el-select>
                                       <el-input class="form_codition" v-else-if="formOneValue.entityField == 'otsRemark'"
                                                 :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)"
                                                 @keyup.enter.native="nextFocus(formOneKey)" type="textarea" v-model="sendDataInfo[formOneValue.entityField]"></el-input>
                                       <el-input class="form_codition" v-else :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2 || (sendDataInfo.detailList.length > 0 && formOneValue.isUpdate == 0)"
                                                 @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                    </el-tooltip>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                               :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.fieldType == 'date'">
                                       {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                    </span>
                                    <span v-else-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                            sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                       <span v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" v-if="item.key == sendDataInfo[formOneValue.entityField]">{{ item.value }}</span>
                                    </span>
                                    <span v-else> {{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 明细信息 -->
                           <div>
                              <el-form :inline="true" size="mini">
                                 <div v-if="dataActionBox.actionType != 2" id="operateBtn">
                                    <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                                       新增</el-button>
                                    <el-button @click="openExtSearch('38643812149')" type="primary" size="mini">
                                       提取请货单
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                    </el-button>

                                 </div>
                                 <el-table size="mini" class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.detailList" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                           @selection-change="handleSelectionChange" border style="width: 100%" :height="mxHeight">
                                    <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                       <template slot-scope="scope">
                                          <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                             <i class="el-icon-thumb"></i>
                                          </el-radio>
                                       </template>
                                    </el-table-column>
                                    <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                                     v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey">
                                       <template slot-scope="scope">
                                          <!-- 显示通用名称 -->
                                          <el-input :ref="formOneValue.entityField" v-if="formOneValue.fieldType == 'search'
                              && dataActionBox.actionType != 2 && formOneValue.isChange == 1" clearable
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, formOneValue.nosetField)"
                                                    v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                             <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, formOneValue.nosetField)"
                                                        slot="append" icon="el-icon-search"></el-button>
                                          </el-input>

                                          <input class="newInput" @keyup.enter="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'num'
                                && dataActionBox.actionType != 2 && formOneValue.isChange == 1" @input="calculatePrice(5, scope.$index)" type="number" v-model="sendDataInfo.detailList[scope.$index].num" />

                                          <!-- 调拨数量 -->
                                          <el-input @blur="priceBlur(scope.$index, formOneValue.entityField)" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                    type="number" v-else-if="formOneValue.entityField == 'dbNum'
                                && dataActionBox.actionType != 2 && formOneValue.isChange == 1" @input="calculateDbPrice(scope.$index)" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                          </el-input>
                                          <!-- 调拨价格 -->
                                          <el-input @blur="priceBlur(scope.$index, formOneValue.entityField)" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                    type="number" v-else-if="formOneValue.entityField == 'dbPsprice'
                                && dataActionBox.actionType != 2 && formOneValue.isChange == 1" @input="calculateDbPrice(scope.$index)" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                          </el-input>

                                          <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                    v-else-if="dataActionBox.actionType != 2 && formOneValue.isChange == 1" v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                          </el-input>
                                             <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" :disabled="true"
                                                     @change="$forceUpdate()" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                             <el-option v-for="(item, index) in JSON.parse(formOneValue.formatterContent)" :key="index" :label="item.key" :value="item.value">
                                             </el-option>
                                          </el-select>
                                          
                                          <span v-else-if="formOneValue.fieldType == 'date'">
                                             <span v-if="scope.row[formOneValue.entityField]">
                                                {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                             </span>
                                          </span>
                                          <span v-else>
                                             {{
                                sendDataInfo.detailList[scope.$index][formOneValue.entityField]
                              }}
                                          </span>
                                       </template>
                                    </el-table-column>
                                 </el-table>
                              </el-form>
                           </div>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <div class="foot">
               <div>
                  <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
                  </el-button>
                  <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
               </div>
               <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
                  <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                     <el-button type="success">{{
                sendDataInfo[itemV.entityField]
              }}</el-button>
                  </el-form-item>
               </el-form>
            </div>
         </div>

      </div>
      <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
         <ExtractionScheme ref="extractionScheme" :id="exId" :ppId="ppId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
      </el-dialog>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>

      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "psOutListAction",
   props: ['actionData'],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      ExtractionScheme
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            orderDate: '',//制单日期
            coName: '',//货主
            coId: '',
            smName: '',//供应商"
            smId: '',
            storeName: '',//门店名称
            storeId: '',//门店id
            stName: '',//货主库房名称
            stId: '',//货主库房id
            detailList: [],
            totalMoney: 0,
            totalNumber: 0,
            totalCount: 0,
            appGmId: '',


         },
         selectedDetailsIndex: 0,
         showTabs: "",
         formDataList: [],
         userOneList: [],
         seId: "",
         seWidth: "",
         height: "",
         seTitle: "",
         seWidth: "",
         DialogVisible: false,
         seType: "",
         smId: "",
         parentSearchData: {
            coId: "",
            storeId: "",
         },
         tables: false,
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         detaislDataInfo: {
            batchno: "",
            bgmId: '',
            bgsId: "",
            expidate: "",
            lotno: "",
            money: 0,
            price: 0,
            prodate: "",
            psmoney: 0,
            psprice: 0,
            sterBatchno: "",
            num: 0,
            inRate: 0,
            bgmName: "",
            spec: "",
            manufacturer: "",
            placeorigin: "",
            bgpUnitmeasurement: "",
            lowestPrice: 0,
            levePrice3: 0,
            levePrice4: 0,
            limdLownum: 0,
            levePrice1: 0,
            levePrice2: 0,
            stName: "",
            ztSl: 0,
            bgpSituation: "",
            bgiType: "",
            limdHighnum: 0,
            bgiManrange: "",
            bgiPerholder: "",
            bgmCode: "",
            bgColor: "",
            storageMode: "",
            stockNum: "",
            psodReserves1: "",
            bgiAppnumber: "",
            lastPuprice: "",
            isDl: "",
            disPreprice: "",
            mne: "",
            packingSpec: "",
            bgiGename: "",
            stId: "",
            lastPirce: 0,
            isJc: "",
            rjXl: 0,
            bgiProrange: "",
            bgiRegistno: "",
            wholeNum: 0,
            scatNum: 0,
            taxAmount: 0,
            pieceNum: 0,
            dbNum: 0,        // 调拨数量
            dbPsprice: 0,    // 调拨价格
            dbPsmoney: 0     // 调拨金额
         },
         selectedRow: [],
         fField: '',
         DialogExtract: false,   //提取
         exId: "",
         exTitle: "",
         exWidth: "",
         ppId: "appGmId",

      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.detailList": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
            this.sendDataInfo.totalCount = newValue.length;
            if (newValue.length > 0) {
               newValue.forEach((item, keys) => {
                  if (this.dataActionBox.actionType != 2) {
                     if (item.dbNum > item.num) {
                        item.dbNum = item.num;
                        this.$message({
                           message: "调拨数量不能大于库存数量",
                           type: "warning",
                        });
                        return
                     }
                  }
                  this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                     3,
                     NP.plus(this.sendDataInfo.totalMoney, item.dbPsmoney)
                  );
                  this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
                     1,
                     NP.plus(this.sendDataInfo.totalNumber, item.dbNum)
                  );
                  this.sendDataInfo.detailList[keys].dbPsmoney = this.$common.getDecimalInfo(
                     3,
                     NP.times(item.dbPsprice, item.dbNum)
                  );
                  // 调拨非含税价格
                  this.sendDataInfo.detailList[keys].dbPrice = this.$common.getDecimalInfo(
                     3,
                     NP.divide(item.dbPsprice, NP.plus(NP.divide(item.inRate, 100), 1))
                  );
                  // 调拨非含税金额
                  this.sendDataInfo.detailList[keys].dbMoney = this.$common.getDecimalInfo(
                     3,
                     NP.times(this.sendDataInfo.detailList[keys].dbPrice, item.dbNum)
                  );
                  // 含税金额
                  this.sendDataInfo.detailList[keys].psmoney = this.$common.getDecimalInfo(
                     3,
                     NP.times(this.sendDataInfo.detailList[keys].psprice, item.dbNum)
                  );
                  // 非含税金额
                  this.sendDataInfo.detailList[keys].money = Number(this.sendDataInfo.detailList[keys].price) * Number(item.dbNum)

               });
            }



         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      //触发提取
      openExtSearch(id) {
         this.exId = id;
         this.exId = id;
         this.DialogExtract = true;
      },
      //提取返回
      async getDataByChen(val) {
         console.log(val)
         if (val != "" || val != undefined) {
            for (let key in val) {
               if (key == "arrlistbychen") {
                  console.log(val, 'var333');
                  this.$http.deliveryOutFtList({
                     ids: [val.appGmId]
                  }).then(res => {
                     console.log(res, 'res3333');
                     if (res.status == 200) {
                        this.sendDataInfo.detailList = res.result.detailList
                        this.sendDataInfo = res.result
                        this.sendDataInfo.orderDate = this.$moment().valueOf();
                     } else {
                        this.$message.error(res.message)
                     }


                  })

                  // this.sendDataInfo.detailList = val.arrlistbychen;
                  // this.parentSearchData.coId = val.coId
                  // this.sendDataInfo.coId = val.coId
                  // this.sendDataInfo.stName = val.stName
                  // this.sendDataInfo.stId = val.stId
                  // this.sendDataInfo.appGmId = val.appGmId
               } else {
                  if (key == 'opmName' && val[key] == null || key == 'depName' && val[key] == null || key == 'depId' && val[key] == null || key == 'opmId' && val[key] == null) {
                     this.sendDataInfo[key] = this.sendDataInfo[key]
                  } else if (val[key] == null || val[key] === "") {
                  } else {
                     this.sendDataInfo[key] = val[key];
                  }
                  if (this.sendDataInfo[key] == null || this.sendDataInfo[key] == 'null') this.sendDataInfo[key] = ''
                  this.sendDataInfo.totalMoney = 0
                  this.sendDataInfo.totalNumber = 0
                  this.sendDataInfo.totalCount = 0
               }
            }
            this.sendDataInfo.detailList.forEach((item, index) => {
               this.sendDataInfo.totalMoney += item.dbPsmoney ? item.dbPsmoney : 0
               this.sendDataInfo.totalNumber += item.dbNum ? item.dbNum : 0
               item.inStName = this.sendDataInfo.stName
               item.inStId = this.sendDataInfo.stId
               // 确保调拨字段有默认值并且是响应式的
               this.$set(item, 'dbPsprice', item.dbPsprice || 0)
               this.$set(item, 'dbNum', item.dbNum || 0)
               this.$set(item, 'dbPsmoney', this.$common.getDecimalInfo(
                  3,
                  NP.times(item.dbPsprice, item.dbNum)
               ))

            })
            this.sendDataInfo.totalCount = this.sendDataInfo.detailList.length
            // let responseData = await this.$http.getOrderId({ ids: [val.psaiId] });
            // this.sendDataInfo.pisOrderauxinfVo = responseData.result;
            this.DialogExtract = false;
            this.$nextTick(() => {
               this.selectedDetailsIndex = 0
               let refsElTable = this.$refs.mxTableRef
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this.selectedDetailsIndex]);
               //  this.nextFocus(0)
               this.tableNextFocus("dbNum", this.selectedDetailsIndex);
            })
         }
         this.parentSearchData.stId = this.sendDataInfo.stId
         this.parentSearchData.cmId = this.sendDataInfo.cmId
         this.parentSearchData.coId = this.sendDataInfo.coId
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },

      priceBlur(index, entityField) {
         this.sendDataInfo.detailList[index][entityField] = this.$common.getDecimalInfo(2, this.sendDataInfo.detailList[index][entityField])
      },
      moneyBlur(index, entityField) {
         this.sendDataInfo.detailList[index][entityField] = this.$common.getDecimalInfo(3, this.sendDataInfo.detailList[index][entityField])
      },
      // 计算价格
      calculatePrice(cate = 1, index) {
         var info = this.sendDataInfo.detailList[index];
         info.num = Number(info.num)
         if (info.num <= 0) {
            this.$message({
               message: "请先填写合理的采购数量",
               type: "error",
            });
            this.$set(info, "num", 0);
            this.$set(info, "price", 0);
            this.$set(info, "money", 0);
            this.$set(info, "psmoney", 0);
            this.$set(info, "psprice", 0);
            return false;
         }
         switch (cate) {
            case 1: // 通过单价计算全部
               // 计算含税价格 单价+单价*税率/100
               var thisPrice = this.$common.getDecimalInfo(
                  2,
                  NP.plus(
                     info.price,
                     NP.divide(NP.times(info.price, info.inRate), 100)
                  )
               );
               this.sendDataInfo.detailList[index].psprice = thisPrice;

               // 计算金额 单价*数量
               this.sendDataInfo.detailList[index].money =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(info.price, info.num)
                  );

               // 计算含税金额 含税价格*数量
               this.sendDataInfo.detailList[index].psmoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(thisPrice, info.num)
                  );
               //计算税额
               this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
               break;
            case 2: // 通过含税价格计算全部
               // this.getGoodsSockPrice(index)	//检测最低价/特价申请

               // 计算单价 含税价格/(税率/100+1)
               var thisPrice = this.$common.getDecimalInfo(
                  2,
                  NP.divide(info.psprice, NP.plus(NP.divide(info.inRate, 100), 1))
               );
               this.sendDataInfo.detailList[index].price = thisPrice;

               // 计算金额 单价*数量
               this.sendDataInfo.detailList[index].money =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(thisPrice, info.num)
                  );

               // 计算含税金额 含税价格*数量
               this.sendDataInfo.detailList[index].psmoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(info.psprice, info.num)
                  );
               //计算税额
               this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
               break;
            case 3: // 通过金额计算全部
               // 计算单价  金额 / 数量
               var thisPrice = this.$common.getDecimalInfo(
                  2,
                  NP.divide(info.money, info.num)
               );
               this.sendDataInfo.detailList[index].price = thisPrice;

               // 计算含税价格 单价+单价*税率/100
               var thisPriceTwo = this.$common.getDecimalInfo(
                  2,
                  NP.plus(
                     thisPrice,
                     NP.divide(NP.times(thisPrice, info.inRate), 100)
                  )
               );
               this.sendDataInfo.detailList[index].psprice = thisPriceTwo;

               // 计算含税金额 含税价格*数量
               this.sendDataInfo.detailList[index].psmoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(thisPriceTwo, info.num)
                  );
               //计算税额
               this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
               break;

            case 4: // 通过含税金额计算全部
               // 计算含税价格  含税金额 / 数量
               var thisPrice = this.$common.getDecimalInfo(
                  2,
                  NP.divide(info.psmoney, info.num)
               );
               this.sendDataInfo.detailList[index].psprice = thisPrice;

               // 计算单价 含税价格/(税率/100+1)
               var thisPriceTwo = this.$common.getDecimalInfo(
                  2,
                  NP.divide(thisPrice, NP.plus(NP.divide(info.inRate, 100), 1))
               );
               this.sendDataInfo.detailList[index].price = thisPriceTwo;
               // 计算金额 单价*数量
               this.sendDataInfo.detailList[index].money =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(thisPriceTwo, info.num)
                  );
               //计算税额
               this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))
               break;
            default:
               //通过数量计算
               // 计算金额 单价*数量

               this.sendDataInfo.detailList[index].money =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(info.price, info.num)
                  );

               // 计算含税金额 含税价格*数量
               var moneyOne = this.$common.getDecimalInfo(
                  3,
                  NP.times(info.psprice, info.num)
               );
               this.sendDataInfo.detailList[index].psmoney = moneyOne;
               // 计算整件数量
               this.sendDataInfo.detailList[index].wholeNum = Math.floor(info.num / Number(info.packingSpec))

               //计算零散数量
               this.sendDataInfo.detailList[index].scatNum = info.num - info.wholeNum * Number(info.packingSpec)

               //计算税额
               this.sendDataInfo.detailList[index].taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money))

               // 计算件数 采数/包装单位
               if (parseFloat(info.packingSpec) <= 0 || info.packingSpec == "") {
                  this.sendDataInfo.detailList[index].pieceNum = 0;
               } else {
                  this.sendDataInfo.detailList[index].pieceNum =
                     this.$common.getDecimalInfo(
                        1,
                        NP.divide(info.num, info.packingSpec)
                     );
               }
               break;
         }

         // 单价
         var moneyOne = this.sendDataInfo.detailList[index].price;
         // 含税价
         var moneyTwo = this.sendDataInfo.detailList[index].psprice;
         // 金额
         var moneyThree = this.sendDataInfo.detailList[index].money;
         // 含税金额
         var moneyFour = this.sendDataInfo.detailList[index].psmoney;

         this.sendDataInfo.totalMoney = moneyFour;
         this.sendDataInfo.totalNumber = info.num;
         this.sendDataInfo.totalCount = this.sendDataInfo.detailList.length;
         this.sendDataInfo.detailList.splice(1, 0)

      },
      // 计算调拨价格
      calculateDbPrice(index) {
         var info = this.sendDataInfo.detailList[index];
         info.dbNum = Number(info.dbNum) || 0;
         info.dbPsprice = Number(info.dbPsprice) || 0;

         // 计算调拨金额 = 调拨价格 * 调拨数量
         this.sendDataInfo.detailList[index].dbPsmoney = this.$common.getDecimalInfo(
            3,
            NP.times(info.dbPsprice, info.dbNum)
         );

         // 重新计算总金额和总数量
         this.recalculateDbTotals();
      },
      // 重新计算调拨总金额和总数量
      recalculateDbTotals() {
         this.sendDataInfo.totalMoney = 0;
         this.sendDataInfo.totalNumber = 0;
         this.sendDataInfo.detailList.forEach(item => {
            this.sendDataInfo.totalMoney += item.dbPsmoney ? item.dbPsmoney : 0;
            this.sendDataInfo.totalNumber += item.dbNum ? item.dbNum : 0;
         });
      },
      deleteDetails() {
         if (this.sendDataInfo.detailList.length < 1) {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
         }
         this.sendDataInfo.detailList.splice(this.selectedDetailsIndex, 1);
         if (this.sendDataInfo.detailList.length > 1) {
            this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
         } else {
            this.selectedDetailsIndex = 0;
         }
         this.tableNextFocus("bgmName", this.selectedDetailsIndex);
         let refsElTable = this.$refs.mxTableRef;
         refsElTable.clearSelection();
         refsElTable.toggleRowSelection(
            this.sendDataInfo.detailList[this.selectedDetailsIndex]
         );
      },

      // 表格切换焦点方法
      tableNextFocus(field, index) {
         console.log(field, index)
         if (field == "keydown") {
            if (this.sendDataInfo.detailList[index + 1] != undefined) {
               this.$refs["bgmName"][index + 1].focus();
               return;
            }
            this.addDetail("sendDataInfo");
            return;
         }
         this.$refs[field][index].focus();
      },
      // 保存已选择行
      handleSelectionChange(rows) {
         this.selectedRow = rows; // 保存已选择行
      },
      // 明细表格点击选中
      clickEvent(row, column, event, params) {
         let refsElTable = this.$refs.mxTableRef; // 获取表格对象
         let findRow = {};
         this.selectedDetailsIndex = row.rowIndex;
         findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
         //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
         if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(row, false);
            return;
         }
         refsElTable.clearSelection();
         refsElTable.toggleRowSelection(row);
      },
      // 表格方法
      rowClassName({
         row,
         rowIndex
      }) {
         let rowName = "",
            findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
         if (findRow) {
            rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
         }
         return rowName; //也可以再加上其他类名 如果有需求的话
      },
      // 选中行底色逻辑
      rowStyle({
         row,
         rowIndex
      }) {
         Object.defineProperty(row, "rowIndex", {
            // 给每行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
         });
      },
      //新增明细
      addDetail(sendDataInfo) {
         console.log(this.sendDataInfo, 'sendDataInfo');

         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               var flag = false
               if (this.sendDataInfo.detailList.length > 0) {
                  this.sendDataInfo.detailList.forEach(item => {
                     if (item.bgmId == "") {
                        flag = true
                        this.$nextTick(() => {
                           this.selectedDetailsIndex = Number(
                              this.sendDataInfo.detailList.length - 1
                           );
                           this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                           let refsElTable = this.$refs.mxTableRef;
                           refsElTable.clearSelection();
                           refsElTable.toggleRowSelection(
                              this.sendDataInfo.detailList[this.selectedDetailsIndex]
                           );
                        });
                     }
                  })
               }
               if (flag) {
                  return
               }
               this.sendDataInfo.detailList.push({})
               var index = this.sendDataInfo.detailList.length - 1
               for (const key in this.detaislDataInfo) {
                  this.$set(this.sendDataInfo.detailList[index], key, this.detaislDataInfo[key])
               }
               // 新增时给明细的inStName赋值为sendDataInfo.stName
               this.$set(this.sendDataInfo.detailList[index], 'inStName', this.sendDataInfo.stName)
               this.$set(this.sendDataInfo.detailList[index], 'inStId', this.sendDataInfo.stId)
               this.$nextTick(() => {
                  this.selectedDetailsIndex = Number(
                     this.sendDataInfo.detailList.length - 1
                  );
                  this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.detailList[this.selectedDetailsIndex]
                  );
               });

            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "warning",
               });
            }
         });
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById('mainInfo')
         if (el) this.inputel = el.getElementsByTagName('input')
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
               this.inputel[index].focus()
               break
            }
         }
      },
      // 输入框切换焦点
      nextFocus(index) {
         if (index >= (this.inputel.length - 1)) return
         var aindex = index + 1
         if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
            this.nextFocus(aindex)
            return
         }
         this.inputel[aindex].focus()
      },
      showPrintPlan() { // 打印方法
         // 调用全局方法 判断Websocket是否连接
         // if (this.$printSocketApi.printExeMsg() != false) {
         //    // 选中的数据
         //    this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
         //       .printJurId)
         // } else {
         //    return
         // }
            this.$http.deliveryOutGetMagType({
                     ids: [this.actionData.orderId]
                  }).then(res => {
                  console.log(res,'res111')
                     if (res.status == 200) {
                        // 调用全局方法 判断Websocket是否连接
                        if (this.$printSocketApi.printExeMsg() != false) {
                           // 选中的数据
                           this.$refs.printPlan.openDiaII(this.actionData.orderId, 'printData/deliveryOutPrint', '18000000803',res)
                        } else {
                           return
                        }
                     }
                  })
      },
      // 默认值
      initDefaultValue() {
         let arr = this.formDataList[0].jurconfigform
         arr.forEach(item => {
            if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
               this.sendDataInfo[item.entityField] = item.defaultValue
            }
         })
      },
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
         else this.$parent.$parent.$parent.toDetail(orderId)
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      //检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField, fField) {
         delete this.parentSearchData.coName
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.fField = fField
         if (type == "bgmName") {
            this.parentSearchData.coId = this.sendDataInfo.coId;
            this.parentSearchData.storeId = this.sendDataInfo.storeId;

            this.parentSearchData.storeName = this.sendDataInfo.storeName;
            this.parentSearchData.bgmName =
               this.sendDataInfo.detailList[this.seIndex].bgmName;
            this.sendDataInfo.detailList[this.seIndex].batchno = ''

            return;
         } else if (type == 'batchno') {
            console.log(93333)
            this.parentSearchData.bgmId = this.sendDataInfo.detailList[this.seIndex].bgmId;



         }
         this.parentSearchData[type] = this.sendDataInfo[type]
         this.parentSearchData.coName = this.parentSearchData[type]
      },
      // 赋值字段
      paramValue(val) {

         if (this.seType == "batchno") {
            console.log(val, 333333)
            // 只更新指定字段，不覆盖整个对象
            let arr = this.sField.split(',')
            arr.forEach(item => {
               this.sendDataInfo.detailList[this.seIndex][item] = val[item]
            })
            // this.sendDataInfo.detailList[this.seIndex].isMag = Number(val.isMag)
            this.tableNextFocus(this.fField, this.seIndex)
         } else if (this.seType == "bgmName") {
            let arr = this.sField.split(',')
            arr.forEach(item => {
               this.sendDataInfo.detailList[this.seIndex][item] = val[item]
            })
            this.tableNextFocus(this.fField, this.seIndex)
         } else {
            let arr = this.sField.split(',')
            arr.forEach(item => {
               this.sendDataInfo[item] = val[item]

            })
            this.$nextTick(() => {
               this.nextFocus(this.seIndex)
            })
         }


      },
      // 表格赋值字段
      mxParamValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.sendDataInfo.detailList[this.seIndex][item] = val[item];
         });
         this.sendDataInfo.detailList.splice(1, 0)
         // this.$nextTick(() => {
         // 	this.tableNextFocus(this.fField, this.seIndex);
         // });
      },
      changeInputModel(val) {
         console.log(val, this.seType)
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            if (this.seType == "bgmName") {
               for (let key in val) {
                  this.sendDataInfo.detailList[this.seIndex][key] =
                     val[key];
                  if (this.sendDataInfo.detailList[this.seIndex][key] == null) this.sendDataInfo.detailList[this.seIndex][key] = ''
               }
               // this.sendDataInfo.detailList[this.seIndex].num = 0
               // this.sendDataInfo.detailList[this.seIndex].money = 0
               // this.sendDataInfo.detailList[this.seIndex].price = 0
               // this.sendDataInfo.detailList[this.seIndex].psprice = 0
               // this.sendDataInfo.detailList[this.seIndex].psmoney = 0
               this.parentSearchData.bgmId = val.bgmId;

               this.tableNextFocus(this.fField, this.seIndex);

            } else if (this.seType == "storeName") {

               this.sendDataInfo.coId = val.coId
               this.sendDataInfo.stId = val.stId
               this.sendDataInfo.stName = val.stName
               this.sendDataInfo.storeId = val.storeId
               this.parentSearchData.coId = val.coId
               this.parentSearchData.storeId = val.storeId
               console.log(this.parentSearchData.coId, 'this.parentSearchData.coId');

            }
            this.paramValue(val)

         }
      },

      initActionBox(sendDataInfo) {
         this.$confirm("确定取消" + this.dataActionBox.boxTitle + "吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.dataActionBox.actionType = 0;
               this.$emit('drawerCancel')
               this.tables = false;
               this.init();
               this.$refs[sendDataInfo].resetFields();
            })
            .catch(() => {
            });
      },
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.detailList = []
      },
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate
         this.formDataList = this.actionData.formData
         var oldData = this.actionData.oldData
         this.showTabs = this.actionData.formData[0].jciName
         this.filterMainField()
         this.init();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            this.sendDataInfo.orderDate = this.$moment().valueOf();
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(this.actionData.oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         } else {
            this.tables = true
            this.dataActionBox.boxTitle = '查看信息'
            var dataInfo = JSON.parse(JSON.stringify(this.actionData.oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
               this.initFocus();
            }, 16.7)
         });



      },
      sendDataAction(sendDataInfo) {
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               this.sub();
            } else {
               console.log("error submit!!");
               return false;
            }
         });
      },
      async sub() {
         if (this.sendDataInfo.detailList.length < 1) {
            this.$message({
               message: "请添加明细",
               type: "error",
            });
            return;
         } else {
            this.sendDataInfo.detailList.forEach((item, index) => {
               if (item.bgmId == "") {
                  this.sendDataInfo.detailList.splice(index, 1);
               }
            });
         }

         if (
            this.sendDataInfo.detailList.some(
               (val) =>
                  (val.bgmName != "" && val.dbNum == "") ||
                  val.dbNum <= 0 ||
                  (val.goodType != 2 && val.dbPsprice <= 0)
            )
         ) {
            this.$message({
               type: "error",
               message: "明细商品调拨数量调拨价格不能为0或者空",
            });
            return;
         }
         this.sendDataInfo.totalCount=this.sendDataInfo.detailList.length
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         if (this.dataActionBox.actionType == 0) {
            // 新增调拨单
            var responseData = await this.$http.deliveryOutAdd(sendData);
         } else {
            // 编辑调拨单
            var responseData = await this.$http.deliveryOutUpdate(sendData);
         }
         if (responseData.status == 200) {
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit('drawerCancel', true)
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
               this.mxForm.forEach(item1 => {
                  if (item1.fieldType == 'number') {
                     this.$set(this.detaislDataInfo, item1.entityField, 0)
                  } else if (item1.fieldType == 'search' && item1.setField) {
                     var arr = item1.setField.split(',')
                     arr.forEach(item2 => {
                        this.$set(this.detaislDataInfo, item2, "")
                     })
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "")
                  }
               })
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
                  .jurconfigform[index])
            }
         })
         var arr = [{ entityField: "detailList" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox()
      })
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput()
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}

.mb {
   margin-bottom: 0;
}

.newInput {
   height: 28px;
   line-height: 28px;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #dcdfe6;
   box-sizing: border-box;
   color: #606266;
   display: inline-block;
   font-size: inherit;
   outline: 0;
   padding: 0 15px;
   transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
   width: 100%;
}
</style>